define('models/strategyTargetSummary',["Underscore", "jQuery", "T1", "Backbone", "T1Model", "T1Collection"], function (_, $, T1, Backbone, T1Model, T1Collection) {
  T1.Models.StrategyTargetSummary = T1Model.extend({
    url: "strategies"
  });
  return T1.Models.StrategyTargetSummary;
});
